import * as React from "react"
import formikCode from "./codeExamples/formikCode"
import reactHookFormCode from "./codeExamples/reactHookFormCode"
import reduxFormCode from "./codeExamples/reduxFormCode"
import CodeArea from "./CodeArea"
import { AnimateGroup, Animate } from "react-simple-animate"
import colors from "../styles/colors"
import home from "../data/home"
import typographyStyles from "../styles/typography.module.css"
import containerStyles from "../styles/container.module.css"
import styles from "./CodeCompareSection.module.css"
import { useStateMachine } from "little-state-machine"
import copyClipBoard from "./utils/copyClipBoard"
import generic from "../data/generic"
import codeAreaStyles from "./CodeArea.module.css"

const props = {
  start: { transform: "translateY(100px)" },
  end: { transform: "translateY(0)" },
  easeType: "ease-in",
}

function CodeCompareSection({
  isPlayCodeCompare,
  currentLanguage,
}: {
  isPlayCodeCompare: boolean
  currentLanguage: string
}) {
  const [showFullScreen, setFullScreen] = React.useState(false)

  const { state } = useStateMachine()
  const lightMode = state?.setting?.lightMode

  return (
    <AnimateGroup play={isPlayCodeCompare}>
      <div
        style={{
          marginBottom: 40,
        }}
      >
        <div className={containerStyles.centerContent} id="installation">
          <h1 className={typographyStyles.h1}>
            {home.usage[currentLanguage].title}
          </h1>

          {home.usage[currentLanguage].description1}

          <p id="codeComparison" className={styles.codeComparison}>
            <span
              className={`${styles.installCode} ${
                lightMode ? styles.lightInstallCode : ""
              }`}
            >
              npm install --global @create-next-app/core
              <button
                className={styles.copyButton}
                onClick={() => {
                  copyClipBoard("npm install --global @create-next-app/core")
                  alert(generic.copied[currentLanguage])
                }}
              >
                <span className={codeAreaStyles.copyIcon}>
                  <span />
                </span>{" "}
                {generic.copy[currentLanguage]}
              </button>
            </span>
          </p>

          <div style={{ marginTop: 30 }}>
            {home.usage[currentLanguage].description2}
            <p id="codeComparison" className={styles.codeComparison}>
              <span
                className={`${styles.installCode} ${
                  lightMode ? styles.lightInstallCode : ""
                }`}
              >
                yarn global add @create-next-app/core
                <button
                  className={styles.copyButton}
                  onClick={() => {
                    copyClipBoard("yarn global add @create-next-app/core")
                    alert(generic.copied[currentLanguage])
                  }}
                >
                  <span className={codeAreaStyles.copyIcon}>
                    <span />
                  </span>{" "}
                  {generic.copy[currentLanguage]}
                </button>
              </span>
            </p>
          </div>
        </div>
      </div>
    </AnimateGroup>
  )
}

export default React.memo(CodeCompareSection)
